import { useEffect, useState } from 'react';
import { marketplaceaccountApi, type MarketplaceAccount } from '../../api/marketplaceaccount';

export function CredentialManagerPage() {
  const [accounts, setAccounts] = useState<MarketplaceAccount[]>([]);
  const [selected, setSelected] = useState('');
  const [credentials, setCredentials] = useState<Record<string, string> | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void marketplaceaccountApi.list().then(setAccounts).catch((e) => setError(String(e)));
  }, []);

  useEffect(() => {
    if (!selected) return;
    void marketplaceaccountApi.credentials(selected).then(setCredentials).catch((e) => setError(String(e)));
  }, [selected]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="text-2xl font-semibold">Credential Manager</h1>
      <p className="mt-1 text-sm text-slate-600">View masked credentials. Secrets are encrypted at rest.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <select className="mt-4 w-full max-w-md rounded border p-2" value={selected} onChange={(e) => setSelected(e.target.value)}>
        <option value="">Select account</option>
        {accounts.map((a) => <option key={a.id} value={a.id}>{a.display_name} ({a.account_code})</option>)}
      </select>
      {credentials && (
        <dl className="mt-6 space-y-2 rounded border bg-white p-4 text-sm">
          {Object.entries(credentials).map(([k, v]) => (
            <div key={k} className="flex gap-4">
              <dt className="w-40 font-medium text-slate-500">{k}</dt>
              <dd>{v}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
